import { Fragment } from 'react';
import { Link } from '@inertiajs/react';

export interface BreadcrumbItem {
  label: string;
  href?: string; // omit on the last/current item
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

// Canonical breadcrumb for the public site: muted text links separated by a
// thin chevron, current page in quieter ink. Light system — no glass pills.
export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav
      className="mb-6 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm"
      aria-label="Breadcrumb"
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <Fragment key={i}>
            {item.href && !isLast ? (
              <Link
                href={item.href}
                className="text-on-surface-light hover:text-primary font-medium transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span
                className="text-on-surface-light/70 truncate"
                aria-current={isLast ? 'page' : undefined}
              >
                {item.label}
              </span>
            )}
            {!isLast && (
              <svg
                className="text-line-strong h-3.5 w-3.5 flex-shrink-0"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                aria-hidden="true"
              >
                <path d="M6 4l4 4-4 4" />
              </svg>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
